import type {MemexColumnDataType} from '../../../api/columns/contracts/memex-column'
import {BaseSingleSelectColumnModel} from '../abstract/base-single-select'

export class SingleSelectColumnModel extends BaseSingleSelectColumnModel {
  declare readonly id: number
  declare readonly dataType: typeof MemexColumnDataType.SingleSelect
  declare readonly userDefined: true
}
